import { useSnackbarContext } from "../context/SnackbarContext";

export const useSnackbar = () => {
  const { setIsOpen, setMessage, setSeverity } = useSnackbarContext();
  return {
    open: (
      message: string,
      severity: "success" | "info" | "warning" | "error"
    ) => {
      setMessage(message);
      setSeverity(severity);
      setIsOpen(true);
    },
  };
};
